import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, of, tap } from 'rxjs';
import { EnvironmentType } from '@env/environment.interface';
import { LanguageStateService } from '@services/language-state.service';

// CD-3557: each environment loads i18n from its OWN Cloudflare R2 host, so the
// bucket CORS policy can scope to that env's origins. This mirrors what the main
// app already does (cd-front-angular, libs/coin-depo-i18n, CD-2983).
//
// Previously this was hardcoded to the shared nginx `lang.coindepo.io` for both
// dev and stage. That was invisible while the dApp was served from the same box,
// but once the SPA moved to a Worker on dev-dapp.coindepo.io the request became
// cross-origin and the browser blocked it: that host sends no
// Access-Control-Allow-Origin. It also 404s on /dapp/*, so it was serving nothing
// either way — the CORS error just surfaces first.
export const LANG_EDGE_HOSTS: Record<EnvironmentType, string> = {
  dev: 'https://dev-lang.coindepo.io',
  stage: 'https://stage-lang.coindepo.io',
  prod: 'https://lang.coindepo.com',
};

export class CustomTranslateHttpLoader extends TranslateHttpLoader {
  private httpClient: HttpClient;

  constructor(
    http: HttpClient,
    private type: 'dapp',
    private lanuage: LanguageStateService,
    prefix: string = './assets/i18n/',
    suffix: string = '.json',
    private env: EnvironmentType = 'dev',
  ) {
    super(http, prefix, suffix);
    this.httpClient = http;
  }

  override getTranslation(lang: string | undefined): Observable<any> {

    if (lang === 'only-key') {
      return of({});
    }
    if (lang === 'undefined' || lang === undefined) {
      lang = 'en';
    }
    if (localStorage.getItem('translate-source') === 'local') {
      return super.getTranslation(lang).pipe(
        catchError(() => of({})),
        tap(() => this.lanuage.setLoadedLanguage())
      );
    }
    const host = LANG_EDGE_HOSTS[this.env] ?? LANG_EDGE_HOSTS.prod;
    return this.httpClient.get(`${host}/${this.type}/${lang}${this.suffix}`).pipe(
      catchError(() => of({})),
      tap(() => this.lanuage.setLoadedLanguage())
    );
  }
}
